import React, { Fragment } from "react";

import {
  PDFViewer,
  PDFDownloadLink,
  Document,
  Page,
  Text,
  View,
  Image,
} from "@react-pdf/renderer";

import styles from "./styles";

import CONFIG from "../../../config";

import { NumberCurrency } from "../../../../lib-atomic-functions";

const totalBody = ({ order }) => {
  const totalAmount_currency = NumberCurrency(order.totalAmount.toFixed(2));
  const paymentType = order.paymentTypeName;
  return (
    <Fragment>
      <View style={[styles.container]}>
        <View style={styles.itemContainer}>
          <Text></Text>
        </View>
        <View
          style={[styles.courierTotalContainer, styles.alignRightContainer]}
        >
          <View style={styles.transparentline}></View>
          <Text>Total:&nbsp;&nbsp;</Text>
        </View>
        <View
          style={[styles.courierTotalContainer2, styles.alignRightContainer]}
        >
          <View style={styles.line}></View>
          <Text style={styles.TotalTitle}>${totalAmount_currency}</Text>
        </View>
      </View>
      <View style={[styles.container, { marginTop: 7 }]}>
        <View
          style={[
            styles.totalContainer,
            styles.alignRightContainer,
            { marginBottom: 0, paddingBottom: 0 },
          ]}
        >
          <Text>PAID IN FULL - THANK YOU</Text>
        </View>
      </View>
      <View style={[styles.container]}>
        <View
          style={[
            styles.totalContainer,
            styles.alignRightContainer,
            { marginTop: 0, paddingTop: 0 },
          ]}
        >
          <Text>{paymentType}</Text>
        </View>
      </View>
    </Fragment>
  );
};

export default totalBody;
